import React from 'react';
import { Copy } from 'lucide-react';
import PropTypes from 'prop-types';

const TransferInstructions = ({ collateralRequired, coin }) => (
  <div className="flex flex-col gap-4 p-3">
    <div className="flex items-center gap-2 text-sm">
      <span className="flex-shrink-0 h-8 w-8 flex font-bold text-blue-500 items-center justify-center bg-blue-200 rounded-full relative after:absolute after:w-[2px] after:h-1/2 after:-translate-x-1/2 after:top-8 after:left-2/4 after:bg-sky-100">1</span>
      <p className="text-slate-800">Copy the wallet address using the <Copy className="inline text-gray-500" size={16} /> icon</p>
    </div>
    <div className="flex items-center gap-2 text-sm">
      <span className="flex-shrink-0 h-8 w-8 flex font-bold text-blue-500 items-center justify-center bg-blue-200 rounded-full relative after:absolute after:w-[2px] after:h-1/2 after:-translate-x-1/2 after:top-8 after:left-2/4 after:bg-sky-100">2</span>
      <p className="text-slate-800">Go to your cryptocurrency wallet or exchange</p>
    </div>
    <div className="flex items-center gap-2 text-sm">
      <span className="flex-shrink-0 h-8 w-8 flex font-bold text-blue-500 items-center justify-center bg-blue-200 rounded-full relative after:absolute after:w-[2px] after:h-1/2 after:-translate-x-1/2 after:top-8 after:left-2/4 after:bg-sky-100">3</span>
      <p className="text-slate-800">Send exactly <span className="font-bold">{collateralRequired} {coin}</span> to the provided address</p>
    </div>
    <div className="flex items-center gap-2 text-sm">
      <span className="flex-shrink-0 h-8 w-8 flex font-bold text-blue-500 items-center justify-center bg-blue-200 rounded-full relative after:absolute after:w-[2px] after:h-1/2 after:-translate-x-1/2 after:top-8 after:left-2/4 after:bg-sky-100">4</span>
      <p className="text-slate-800">Confirm the transaction details before sending</p>
    </div>
    <div className="flex items-center gap-2 text-sm">
      <span className="flex-shrink-0 h-8 w-8 flex font-bold text-blue-500 items-center justify-center bg-blue-200 rounded-full">5</span>
      <p className="text-slate-800">Wait while your transfer is being confirmed on the blockchain</p>
    </div>
  </div>
);

TransferInstructions.propTypes = {
  coin: PropTypes.string.isRequired,
  collateralRequired: PropTypes.number.isRequired,
};

export default TransferInstructions;
